import { render, staticRenderFns } from "./ManageCampaign.vue?vue&type=template&id=98aeeaee&"
import script from "./ManageCampaign.vue?vue&type=script&lang=js&"
export * from "./ManageCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports